"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const core_1 = require("@emotion/core");
const PathDropdownItemStyles = {
    container: ({ isActive }) => core_1.css({
        alignItems: 'center',
        backgroundColor: isActive ? design_system_1.Colors.blue100 : 'transparent',
        color: isActive ? design_system_1.Colors.blue500 : '',
        cursor: 'pointer',
        display: 'flex',
        height: '40px',
        padding: '0 10px',
        '&:hover': {
            backgroundColor: theme_1.Colors.storm,
        },
    }),
    clickableSection: core_1.css({
        display: 'flex',
        alignItems: 'center',
        flex: '1 1 0',
    }),
    pathIconBorder: core_1.css({
        backgroundColor: theme_1.Colors.white,
        border: `1px solid ${theme_1.Colors.adamantium}`,
        borderRadius: '4px',
        marginRight: '10px',
        padding: '5px',
    }),
    pathName: core_1.css({
        alignItems: 'center',
        display: 'flex',
        lineHeight: 'normal',
        width: '200px',
        '&:hover': {
            textDecoration: 'underline',
        },
    }),
    childPaths: core_1.css({
        width: '100%',
    }),
};
exports.default = PathDropdownItemStyles;
